import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { LoaderService } from '../../services/loader/loader.service';
import { BrandingService } from '../../services/branding/branding.service';

@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss']
})
export class LoaderComponent implements OnInit {

  $bIsLoaderActive!: Observable<boolean>;

  constructor(
    private loaderService: LoaderService,
    private brandingService: BrandingService
  ) { }

  ngOnInit(): void {
    this.getLoaderActualState();
  }

  getLoaderActualState() {
    this.$bIsLoaderActive = this.loaderService.getLoaderState();
  }

  get logoUrl(): string {
    return this.brandingService.snapshot?.logo_url || '/assets/images/kino-logo.svg';
  }

}
